import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateInstitutionUser = (props) => {
  return (
    <Create
// @ts-ignore
      title='Add User to Institution'
      fields={fields}
      apiPath='admin/institution_users'
      successRedirectPath={resource => `/membership/institution-users/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateInstitutionUser
